"use client"

import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/shad"
import { cn } from "@ui/utils"
import { Pencil } from "lucide-react"

import { getIconComponent } from "@/components/automations/edit-panel/triggers/icon-color-picker-input"

interface PromptSnippetPillProps {
  title: string
  icon?: string
  color?: string
  className?: string
  onEditClick?: () => void
  editTooltip?: string
}

export function PromptSnippetPill({ title, icon, color, className, onEditClick, editTooltip }: PromptSnippetPillProps) {
  const Icon = getIconComponent(icon)

  return (
    <Badge
      variant="outline"
      size="base"
      className={cn(
        "border-border bg-background text-foreground inline-flex items-center gap-1.5 pl-1.5 text-sm!",
        className
      )}
      clickable
    >
      <span
        className="inline-flex size-4 items-center justify-center rounded-full"
        style={{ backgroundColor: color || "#0EA5E9" }}
      >
        <Icon className="size-2.5 text-white" />
      </span>
      <span className="truncate">{title}</span>
      {onEditClick && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                onClick={(event) => {
                  event.stopPropagation()
                  onEditClick()
                }}
                className="text-icon hover:text-icon-hover ml-auto inline-flex size-4 items-center justify-center rounded-full"
                aria-label={editTooltip || "Edit snippet"}
              >
                <Pencil className="size-3" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top">
              <span>{editTooltip || "Edit snippet"}</span>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </Badge>
  )
}
